module.exports = __webpack_public_path__ + "static/MicrosoftSQLServer-26ba0b5cc5bc36cfcb31e106e1565e7d.png";